import tw from 'tailwind-styled-components'

export const SRBigCalendarEventWeekStyle = tw.div`
  flex
  h-full
  text-sm
  flex-row
  items-center
  justify-center
  
`

export const SRBigCalendarEventWeekBlockStyle = tw.div`
  flex
  flex-col
  justify-center
  items-center
  gap-1
`
